import script from "./status-pie-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./status-pie-chart.vue?vue&type=script&lang=ts&setup=true"

import "./status-pie-chart.vue?vue&type=style&index=0&id=6e56d800&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e56d800"]])

export default __exports__